export default {
  title: 'Sie haben Einladungen zu folgenden Organisationen erhalten',
  your_role: 'Ihre Rolle:',
  accept: 'Akzeptieren',
  decline: 'Ablehnen',
  accepted: 'Akzeptiert',
  declined: 'Abgelehnt',
  continue: 'Weiter',
  skip: 'Überspringen',
  accepted_success:
    'Sie haben die Einladung zu {organization} erfolgreich angenommen',
  declined_success: 'Sie haben die Einladung zu {organization} abgelehnt',
  success_title: 'Fast geschafft!',
  success_text:
    'Melden Sie sich mit Ihrer E-mail Adresse und Ihrem Passwort an, um die Registrierung abzuschließen.',
  finish_registration: 'Registrierung abschließen',
}
